/* eslint semi: 1 */
import _ from 'lodash';
import { hasPermissionToCreate, hasPermissionToAccess } from './permissions-common';
/**
 * LED Page accessability
 * - User must be an enterprise user, regardless non-empty tags and possess user_create or user_creat_lock or user_schedule or user_admin rights
 * - User with assigned resourceTags tags must have at least one resourceTag that aligns with the current LED tags.
 */
export const hasAccessToLEDPage = (currentUser, LEDTags) => {
  if (_.isEmpty(currentUser)) {
    return false;
  }

  return currentUser.isEnterpriseUser() && hasPermissionToAccess(currentUser, LEDTags);
};

/**
 * Permission to create LED Project
 */
export const hasPermissionToCreateLEDProject = (currentUser) => {
  if (_.isEmpty(currentUser)) {
    return false;
  }

  return currentUser.isEnterpriseUser() && hasPermissionToCreate(currentUser);
};

/**
 * Permission to create LED Resolution tag
 */
export const hasPermissionToCreateLEDResolutionTag = (currentUser) => {
  let res = false;

  if (_.isEmpty(currentUser)) {
    return res;
  }

  if (currentUser.hasGroupDealerLED() || currentUser.hasGroupDevelopment()) {
    res = true;
  }

  return res;
};
